import { HttpException, HttpStatus, Injectable } from '@nestjs/common';
import { UserEntity } from './user.entity';
import { getConnection, Repository } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { UserDto, LoginUserDto, CreateUserDto, updateUserDto, UpdateUserDto } from './dto/user.dto';
import { toUserDto } from './mapper';
import * as bcrypt from 'bcrypt';
import { ErrorResponse, LoginUserModel } from '@gtpl/shared-models/common-models';
import { UserResponseModel, UserStatusWiseResponseModel } from '@gtpl/shared-models/gtpl';
import { UserRequest } from './dto/user.request';
@Injectable()
export class UserService {
  constructor(
    @InjectRepository(UserEntity)
    private readonly userRepo: Repository<UserEntity>,) { }
  async findOne(options?: object): Promise<UserDto> {
    const user = await this.userRepo.findOne(options);
    return toUserDto(user);
  }

  async findByLogin({ username, password }: LoginUserDto): Promise<LoginUserModel> {
    console.log(password);
    // get only the active users
    const user = await this.userRepo.findOne({ where: { username, isActive: true } });
    console.log(user);
    if (!user) {
      throw new ErrorResponse(11106, 'User Not Found');
      // throw 'User not found, HttpStatus.UNAUTHORIZED)';    
    }
    let checkPassword = await bcrypt.compareSync(password, user.password);
    if (!checkPassword) {
      throw new ErrorResponse(11106, 'UnMatched password for the user');
      // throw 'User not found, HttpStatus.UNAUTHORIZED)';    
    }

    // compare passwords    
    // const areEqual = await comparePasswords(user.password, password);
    const areEqual = true;
    if (!areEqual) {
      throw 'new HttpException(Invalid credentials, HttpStatus.UNAUTHORIZED)';
    }

    return {
      id: user.id,
      username: user.username,
      mobileNumber: user.mobileNumber,
      email: user.email,
      employeeRole: user.employeeRole,
      unitId: user.unitId,
      versionFlag: user.versionFlag,
      plantType:null
    };
  }
  async findByPayload({ username }: any): Promise<UserDto> {
    return await this.findOne({
      where: { username }
    });
  }
  async create(userDto: CreateUserDto): Promise<UserDto> {
    const { id, username, password, mobileNumber, employeeRole, employeeId, email, unitId } = userDto;

    // check if the user exists in the db    
    const userInDb = await this.userRepo.findOne({
      where: { username }
    });
    console.log(userInDb);
    if (userInDb) {
      console.log('user exists')
      throw new HttpException('User already exists', HttpStatus.BAD_REQUEST);
    }

    const user: UserEntity = await this.userRepo.create({ username, password, mobileNumber, employeeRole, employeeId, email, unitId });
    await this.userRepo.save(user);
    return toUserDto(user);
  }
  async update(userDto: updateUserDto): Promise<any> {
    const { id, username, password, mobileNumber, email, employeeRole, employeeId, isActive, unitId } = userDto;

    // check if the user exists in the db    
    const userInDb = await this.userRepo.findOne({
      where: { username }
    });
    // console.log(userInDb);
    if (!userInDb) {
      throw new ErrorResponse(11106, 'User not found');
      // throw new ('User not found', HttpStatus.BAD_REQUEST);    
    }
    isActive === undefined ? true : isActive;
    const usrObj = password ? { id: userInDb.id, username, password, mobileNumber, email, employeeRole, employeeId, isActive, unitId } : { id: userInDb.id, username, mobileNumber, email, employeeRole, employeeId, isActive, unitId };
    // const user = await this.userRepo.update(userInDb.id, usrObj);

    // console.log(user);
    // userInDb.
    // try{
    const userEntity: UserEntity = await this.userRepo.create(usrObj);
    if (password) {
      const pswrd = await bcrypt.hash(password, 10);
      userEntity.password = pswrd;
    }

    const user = await this.userRepo.save(userEntity);
    // const res = await this.userRepo.save(user);
    // } catch(err){
    //   console.log(err);
    // }

    // console.log('hii');
    return true;
  }
  async getEmpid(userid: Number): Promise<Number> {
    console.log('User Id' + userid);
    const userInDb = await this.userRepo.findOne({
      where: { id: userid }
    });
    console.log('user service employeeId = ' + userInDb.employeeId);
    return userInDb.employeeId;
  }
  async getUserInfo(userid: number): Promise<any> {
    const userInDb = await this.userRepo.findOne({
      where: { id: userid }
    });
    console.log('user service employeeId = ' + userInDb.username);
    return userInDb;
  }
  async getAllUsers(): Promise<any> {
    // console.log();
    // const users = await this.userRepo.find({
    //   relations:["employeeDetails"],
    //   order: { 'username': 'ASC' },
    // });
    const users = await this.userRepo
      .createQueryBuilder('User')
      .leftJoinAndSelect('User.empInfo', 'empInfo')
      .orderBy("User.username", "ASC").getMany();
    // console.log('user service employeeId = '+userInDb);
    return users;
  }

  async getUserById(userId: number): Promise<UserEntity> {
    //  console.log(employeeId);
    const Response = await this.userRepo.findOne({
      where: { id: userId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async activateOrDeactivateUser(userReq: UserRequest): Promise<UserResponseModel> {
    try {
      const userExists = await this.getUserById(userReq.id);
      if (userExists) {
        if (userReq.versionFlag !== userExists.versionFlag) {
          throw new ErrorResponse(10113, 'Someone updated the current user information.Refresh and try again');
        } else {

          const userStatus = await this.userRepo.update(
            { id: userReq.id },
            { isActive: userReq.isActive, updatedUser: userReq.updatedUser });

          if (userExists.isActive) {
            if (userStatus.affected) {
              const userResponse: UserResponseModel = new UserResponseModel(true, 10115, 'user is de-activated successfully');
              return userResponse;
            } else {
              throw new ErrorResponse(10111, 'user is already deactivated');
            }
          } else {
            if (userStatus.affected) {
              const userResponse: UserResponseModel = new UserResponseModel(true, 10114, 'user is activated successfully');
              return userResponse;
            } else {
              throw new ErrorResponse(10112, 'user is already  activated');
            }
          }
          // }
        }
      } else {
        throw new ErrorResponse(99998, 'No Records Found');
      }
    } catch (err) {
      throw err;
    }
  }
  // async getActiveUsersCount(): Promise<UserStatusWiseResponseModel> {
  //   const page: number = 1;
  //   const response = new UserStatusWiseResponseModel();
  //   try {
  //     //retrieves all companies
  //     const usersStatusWiseCount = await getConnection()
  //     .createQueryBuilder()
  //     .select("Sum(IF(status = true, 1, 0)) as activeCount,Sum(IF(status = false, 1, 0)) as inActiveCount, count(*) as cnt")
  //     .from(UserEntity, "UserEntity")
  //     .orderBy('status','ASC')
  //     .getRawOne();

  //     if (response) {
  //       response.status = true;
  //       response.active = usersStatusWiseCount.activeCount;
  //       response.inActive = usersStatusWiseCount.inActiveCount;
  //       response.total = usersStatusWiseCount.cnt;
  //       response.statusCode = 50000;
  //       response.internalMessage = 'Employees retrieved successfully';
  //       response.intlCode = 11108;
  //     } else {
  //       throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //     }
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  async getAllActiveUser(): Promise<any> {
    console.log();
    // const users = await this.userRepo.find({
      
    //   order: { "username": "ASC"},
    //   where: { "isActive" : "1"}
    // });
    const users = await this.userRepo
      .createQueryBuilder('User')
      .leftJoinAndSelect('User.empInfo', 'empInfo')
      .orderBy("User.username", "ASC")
      .where(`User.is_active=1`)
      .getMany();
      
    // console.log('user service employeeId = '+userInDb);
    return users;
  }

  /**
   * gets the active user by the given UID
   * @param userId 
   * @returns 
   */
  async getActiveUserById(userId: string): Promise<LoginUserModel> {
    const user = await this.userRepo.findOne({where: { id: userId, isActive: true } });
    if(!user) {
      throw new ErrorResponse(0, 'User not found. Please retry again');
    }
    return {
      id: user.id,
      username: user.username,
      mobileNumber: user.mobileNumber,
      email: user.email,
      employeeRole: user.employeeRole,
      unitId: user.unitId,
      versionFlag: user.versionFlag,
      plantType:null
    };
  }
}
